import React from "react";
import { MessageSquare, BrainCircuit, Network } from "lucide-react";

const Features = () => {
  const ejes = [
    {
      icon: <MessageSquare />,
      title: "Narrativa del bien común ",
      desc: (
        <>
          <p>
            En un contexto donde la comunicación se define por la velocidad, la
            saturación de contenidos y la disputa por la atención, las
            universidades católicas están llamadas a ir más allá de informar: a 
            <b> construir relatos con sentido. </b>{" "}
          </p>
          <p>
            Esta línea propone reflexionar sobre cómo traducir la misión
            universitaria en historias que hagan visible su impacto educativo,
            social y cultural. Una invitación a articular propósito, identidad y
            comunicación en mensajes que conecten, generen confianza y
            proyecten, con autenticidad, el verdadero aporte de la universidad a
            la sociedad: el bien común.{" "}
          </p>
        </>
      ),
    },
    {
      icon: <BrainCircuit />,
      title:
        "Desafíos contemporáneos: la IA en los procesos de comunicación de las universidades católicas ",
      desc: (
        <>
          <p>
            La inteligencia artificial está transformando
            la forma en que las universidades comunican, gestionan
            su marca y se relacionan con sus audiencias. Para las universidades
            católicas, este avance representa no solo una oportunidad de
            innovación, sino también un <b>reto ético y estratégico:</b>{" "}
            integrar estas tecnologías sin perder la centralidad de la persona,
            la autenticidad del mensaje y la coherencia con su misión.
          </p>
          <p>
            Una invitación a explorar cómo la tecnología puede potenciar la
            comunicación universitaria sin desdibujar su identidad,
            fortaleciendo la confianza y el vínculo con la sociedad en un
            entorno cada vez más automatizado.
          </p>
        </>
      ),
    },
  ];

  return (
    <section className="section-padding">
      <h2
        style={{
          color: "#c4923e",
          fontSize: "12px",
          textTransform: "uppercase",
          letterSpacing: "3px",
          fontWeight: "bold",
        }}
      >
        Ejes del Encuentro
      </h2>
      <h3
        className="font-serif"
        style={{ fontSize: "3rem", color: "#1a2b56", marginBottom: "1rem" }}
      >
        Líneas Temáticas
      </h3>
      <div
        style={{
          width: "60px",
          height: "4px",
          backgroundColor: "#c4923e",
          marginBottom: "3rem",
        }}
      ></div>
      <div className="features-grid">
        {ejes.map((eje, i) => (
          <div key={i} className="feature-card">
            <div className="feature-icon-box">{eje.icon}</div>
            <h4
              style={{
                fontSize: "1.25rem",
                color: "#1a2b56",
                marginBottom: "1rem",
                fontWeight: "bold",
              }}
            >
              {eje.title}
            </h4>
            <p style={{ color: "#6b7280" }}>{eje.desc}</p>
          </div>
        ))}
      </div>
      <center>
        <h2>
          Participa en el encuentro con la exposición de una buena práctica de
          tu institución{" "}
        </h2>
<div className="btn-features"> 
            <a className="btn-primary bg-gold" href="https://forms.office.com/pages/responsepage.aspx?id=rYS9WiLvfE24531Sr_kZ_RoGkOxLh8dBiN9sULBKMvFUQk8xU0FKRFJONUZGNENVT1ZUQU04TzRNRy4u&route=shorturl " >Postular </a>
        </div>
      </center>{" "}
    </section>
  );
};

export default Features;
